import { useNavigate } from 'react-router-dom'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Box,
  Typography,
  Paper,
} from '@mui/material'
import { Dashboard, BarChart, CheckCircle, Camera } from '@mui/icons-material'
import { useState } from 'react'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'

type Category = {
  label: string
  path: string
  icon: JSX.Element
}
const categories = [
  { label: 'Scenarios', path: 'scenarios', icon: <Dashboard /> },
  { label: 'Analysis', path: 'analysis', icon: <BarChart /> },
  { label: 'Approval', path: 'approval', icon: <CheckCircle /> },
  { label: 'Snapshot', path: 'snapshot', icon: <Camera /> },
  // { label: 'Table', path: 'table', icon: <Camera /> },
  // { label: 'Sc Table', path: 'scenario-table', icon: <Camera /> },
]

export const NavigationView = () => {
  const navigate = useNavigate()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const handleNavigation = (path: string) => {
    navigate(path)
  }
  const handleListItemButtonClick = (
    event: React.MouseEvent,
    category: Category,
    index: number
  ) => {
    setSelectedIndex(index)
    handleNavigation(category.path)
  }

  return (
    <Box
      display="flex"
      sx={{
        width: '100px',
        height: '100%',
        minHeight: 0,
        flexShrink: 0,
      }}
    >
      <Paper
        elevation={0}
        sx={{ 
          width: '100%', 
          borderRadius: '0px', 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <List sx={{ textAlign: 'center', flex: 1 }}>
          {categories.map((category, index) => (
            <ListItem key={category.label} disablePadding>
              <ListItemButton
                selected={selectedIndex === index}
                sx={{ flexDirection: 'column', gap: 1 }}
                onClick={(event) =>
                  handleListItemButtonClick(event, category, index)
                }
              >
                <ListItemIcon sx={{ justifyContent: 'center', minWidth: 0 }}>
                  {category.icon}
                </ListItemIcon>
                <Typography variant="caption">{category.label}</Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  )
}
